import { useState, useEffect } from 'react';
import { ProgressBar } from 'react-bootstrap';
import sample from 'lodash/sample';

import Loader from '../Loader';
import NuLoader from '../NuLoader';

import styles from './_index.module.scss';

export interface LoaderViewProps extends React.HTMLAttributes<HTMLDivElement> {
  heading?: string;
  isNuLoader?: boolean;
  messages?: string[];
  progress?: number;
}

const LoaderView = ({
  children,
  heading,
  isNuLoader,
  messages = [],
  progress = 0,
}: LoaderViewProps) => {
  const [text, setText] = useState(sample(messages));

  useEffect(() => {
    // only messages length one should reactively update
    if (messages.length === 1) {
      setText(messages[0]);
    }
  }, [messages]);

  return (
    <div className={styles['loader-view']}>
      {heading && <h2>{heading}</h2>}
      {isNuLoader ? (
        <>
          <NuLoader isCentered />
          <ProgressBar className={styles['loader-view-progress-bar']} now={progress} />
        </>
      ) : (
        <Loader isCentered />
      )}
      {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
      {children && <div className={styles['loader-view-children']}>{children}</div>}
    </div>
  );
};

export default LoaderView;
